export const UPDATE_MAIL_TEMPLATE_REQUEST = 'UPDATE_MAIL_TEMPLATE_REQUEST';

export const updateMailTemplateRequest = ( id, updateData ) => ({
    type: UPDATE_MAIL_TEMPLATE_REQUEST,
    payload: {
        id,
        updateData
    }
});
